import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Card, Icon, Spin } from 'antd';

import { isNull } from 'lodash';

import ToCarView from '../../../../common/icons/CarIcon';

import { daysToM, status, fidelity } from './renders';
import { QsHelper, carsHelper } from '../../../../helpers';

import './CarListTable.css';
import { observer, inject } from 'mobx-react';

import AirTable from 'air-ptable';

import BadgeBar from './BadgeBar';
import api from '../../../../services/api';

import { isFunction } from 'lodash';

@withRouter
@inject('translationsStore', 'carsStore', 'authStore')
@observer
export default class CarListTable extends Component {
  constructor(props) {
    super(props);
    const { carsStore } = this.props;
    this.defaultCachedPage = 1;
    this.state = {
      cars: [],
      dealers: [],
      filters: {},
      cacheKey: carsStore.cacheKey,
      cachedPage: { [carsStore.cacheKey]: this.defaultCachedPage }
    };
    this.FiltersRef = React.createRef();
    this.SearchRef = React.createRef();
  }

  componentWillMount() {
    const { carsStore } = this.props;
    this.setState({ cacheKey: carsStore.cacheKey });
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    const { carsStore } = this.props;
    if (carsStore.cacheKey !== nextState.cacheKey) {
      this.setState({ cacheKey: carsStore.cacheKey });
    }
  }

  componentDidMount = () => {
    const { authStore } = this.props;
    authStore.isAdmin &&
      api('getAllDealers').then(dealers =>
        this.setState({
          dealers: dealers
        })
      );
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { carsStore } = this.props;
    const metaData = window.localStorage.getItem(carsStore.cacheKey);
    const cachedPage = Number(metaData);
    if (metaData && this.state.cachedPage[carsStore.cacheKey] !== cachedPage) {
      this.setState({ cachedPage: { ...this.state.cachedPage, [carsStore.cacheKey]: cachedPage } });
    } else if (
      prevState.cacheKey === carsStore.cacheKey &&
      this.props.cars.length !== prevProps.cars.length &&
      this.state.cachedPage[carsStore.cacheKey] !== this.defaultCachedPage
    ) {
      this.invalidateCachedPage();
    }
  };

  invalidateCachedPage = () => {
    const { carsStore } = this.props;
    this.setState({ cachedPage: { ...this.state.cachedPage, [carsStore.cacheKey]: this.defaultCachedPage } }, () => {
    });
  };

  onPageChange = page => {
    const { carsStore } = this.props;
    if (isFunction(this.props.onChangingPage)) {
      this.props.onChangingPage({ page }, args => {
      });
    }
    this.setState({ cachedPage: { ...this.state.cachedPage, [carsStore.cacheKey]: page } }, () => {
      window.localStorage.setItem(carsStore.cacheKey, page);
    });
  };

  onSortChange = sorter => {
    const { carsStore } = this.props;
    if (isFunction(this.props.onSortingPage)) {
      const page = this.state.cachedPage[carsStore.cacheKey],
        { field: sort, order } = sorter;
      this.props.onSortingPage({ page, sort, order }, args => {
      });
    }
  };

  render() {
    const { translationsStore, carsStore, authStore } = this.props;
    const { filters } = this.state;

    const getFidelity = record => record.client.fidelityIndex || 0;

    const columns = [
      {
        dataIndex: 'leadId',
        align: 'center',
        width: '50px',
        title: translationsStore.translate('carList.table.column.lead'),
        render: leadId => <span className={`${!!leadId ? 'withLead' : ''}`}>{!!leadId && <Icon type="check-circle" theme="outlined" />}</span>
      },
      {
        dataIndex: 'fidelity',
        width: '50px',
        title: 'F.I.',
        // sorter: (a, b) => (getFidelity(a) < getFidelity(b) ? -1 : getFidelity(a) === getFidelity(b) ? 0 : 1),
        render: (text, record) => fidelity(record.client.fidelityIndex)
      },
      {
        dataIndex: 'kmPerDay',
        width: '60px',
        align: 'center',
        // sorter: (a, b) => (a.kmPerDay < b.kmPerDay ? -1 : a.kmPerDay === b.kmPerDay ? 0 : 1),
        sorter: true,
        className: 'kmPerDay',
        title: `${translationsStore.translate('lead.table.column.mainKmDay.km')} ${translationsStore.translate('lead.table.column.mainKmDay.day')}`,
        render: text => (
          <div style={{ fontWeight: 'bold', color: `${text > 50 ? 'var(--red-dtc-color)' : text > 16 ? 'var(--orange-dtc-color)' : 'var(--green-ok)'}` }}>{Math.round(text)}</div>
        )
      },
      {
        dataIndex: 'client',
        width: '120px',
        className: 'client',
        title: translationsStore.translate('lead.table.column.client'),
        render: (text, record) => (record.client ? (record.client.fullName ? record.client.fullName : record.client.companyName) : '-')
      },
      {
        dataIndex: 'car',
        width: '120px',
        title: translationsStore.translate('lead.table.column.car'),
        render: (text, record) => record.make.descrizione + ' ' + record.model.descrizione
      },
      {
        dataIndex: 'plate',
        width: '66px',
        title: translationsStore.translate('lead.table.column.plate'),
        filteredValue: filters.plate || null,
        onFilter: (value, record) => record.plate === value
      },
      {
        dataIndex: 'status',
        width: '100px',
        align: 'center',
        title: translationsStore.translate('lead.table.column.carStatus'),
        className: 'carStatus',
        render: status,
        // sorter: (a, b) => (a.statusWeight < b.statusWeight ? -1 : a.statusWeight === b.statusWeight ? 0 : 1)
        sorter: true
      },
      {
        dataIndex: 'registrationYear',
        width: '70px',
        align: 'center',
        // sorter: (a, b) => (a.registrationYear < b.registrationYear ? -1 : a.registrationYear === b.registrationYear ? 0 : 1),
        sorter: true,
        title: translationsStore.translate('carView.car.registrationYear')
      },
      {
        dataIndex: 'subscriptionEnd',
        width: '100px',
        align: 'center',
        // sorter: (a, b) => (a.subscriptionEnd < b.subscriptionEnd ? -1 : a.subscriptionEnd === b.subscriptionEnd ? 0 : 1),
        sorter: true,
        title: translationsStore.translate('carView.car.subscriptionEnd')
      },
      {
        dataIndex: 'alimentation',
        width: '105px',
        align: 'center',
        title: translationsStore.translate('carView.car.alimentation'),
        render: alimentation => translationsStore.translate(`alimentation.${alimentation}`)
      },
      {
        dataIndex: 'km',
        width: '65px',
        align: 'center',
        // sorter: (a, b) => ((a.km || 0) < (b.km || 0) ? -1 : (a.km || 0) === (b.km || 0) ? 0 : 1),
        sorter: true,
        title: translationsStore.translate('common.mileage'),
        render: (text, record) => {
          let odometer;
          if (record.odometer && record.odometer.value) {
            odometer = record.odometer.value;
          } else if (record.gpsOdometer && record.gpsOdometer.value) {
            odometer = record.gpsOdometer.value + record.initialOdometer;
          } else if (record.initialOdometer) {
            odometer = record.initialOdometer;
          }
          return odometer !== undefined ? Math.round(odometer).toLocaleString() : <div>&mdash;</div>;
        }
      },
      {
        dataIndex: 'daysToM',
        width: '72px',
        align: 'center',
        // sorter: (a, b) => (a.daysToM < b.daysToM ? -1 : a.daysToM === b.daysToM ? 0 : 1),
        title: `${translationsStore.translate('lead.table.column.mainDay.days')} ${translationsStore.translate('lead.table.column.mainDay.main')}`,
        render: (text, record) => {
          record = {...record, daysToM: carsHelper.daysToFutureM(record)};
          return daysToM(record.daysToM, record);
        }
      }
    ];

    if (authStore.isAdmin) {
      columns.push({
        dataIndex: 'dealerId',
        width: '72px',
        align: 'center',
        title: translationsStore.translate('common.dealer'),
        render: (value, record) => (record.dealer || {}).name
      });
    }

    columns.push({
      dataIndex: '',
      width: '50px',
      title: '',
      className: 'goToCarview',
      render: (text, record) => <ToCarView style={{ cursor: 'pointer', fontSize: '2rem' }} onClick={() => this.props.history.push(`/carview/${record.id}?from=carlist`)} />
    });

    return (
      <Card className="CarListTable" bodyStyle={{ padding: '24px 20px', position: 'relative' }}>
        {this.props.loading && (
          <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center' }}>
            <Spin tip={translationsStore.translate('loading.message')} size={'large'} />
          </div>
        )}
        {!this.props.loading && <BadgeBar loading={this.props.loading} style={{ position: 'absolute', width: 900, height: 40 }} />}
        {!this.props.loading && (
          <AirTable
            rowKey="id"
            rowSelection={false}
            columns={columns}
            dataSource={this.props.cars || []}
            virtualDataSource={this.props.virtualCars}
            virtualDataSourceCount={this.props.virtualCarsCount}
            pagination={{ pageSize: 10, position: 'both', current: this.state.cachedPage[carsStore.cacheKey] }}
            onPageChange={this.onPageChange}
            onChange={(pagination, filters, sorter) => {
              this.onSortChange(sorter);
            }}
          />
        )}
      </Card>
    );
  }
}
